export default __webpack_public_path__ + "static/media/sushi.15439b50.png";